module.exports = __webpack_public_path__ + "img/ex04.1cceb56f.png";